import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { chatService } from "../api/chatService";
import { Auth } from "../service/utils/auth";

const ChatContext = createContext({ unreadCount: 0, recentConversations: [], refreshUnread: () => {} });

export function ChatProvider({ children }) {
  const { userID } = new Auth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [recentConversations, setRecentConversations] = useState([]);

  const refreshUnread = async () => {
    if (!userID) return;
    const count = await chatService.getUnreadCount(userID);
    setUnreadCount(count || 0);
  };

  const refreshRecent = async () => {
    if (!userID) return;
    const list = await chatService.getRecentConversations(userID, 1, 10);
    setRecentConversations(list);
  };

  useEffect(() => {
    refreshUnread();
    refreshRecent();
    const interval = setInterval(() => {
      refreshUnread();
    }, 30000); // 30s polling
    return () => clearInterval(interval);
  }, [userID]);

  const value = useMemo(() => ({ unreadCount, recentConversations, refreshUnread }), [unreadCount, recentConversations]);

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
}

export function useChat() {
  return useContext(ChatContext);
}


